import { icons, labelDefaultRegularStyles } from '@lifebit-ai/lds'
import styled, { css } from 'styled-components'

export const LoadingContainer = styled.div`
  svg {
    height: ${({ theme }) => theme.size.icon.small};
    width: ${({ theme }) => theme.size.icon.small};
  }
`

export const EmptyStateContainer = styled.div`
  ${labelDefaultRegularStyles};
  color: ${({ theme }) => theme.color.content.main};
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.size.space['08']};
  width: 100%;
`

export const RetryButton = styled.button<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['02']};
  color: ${({ theme, $disabled }) => ($disabled ? theme.color.content.disabled : theme.color.content.secondary)};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;

  svg {
    height: ${({ theme }) => theme.size.icon.small};
    width: ${({ theme }) => theme.size.icon.small};
  }
`

export const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['03']};
  flex-wrap: wrap;
`

export const FiltersVisibilityButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['04']};

  button {
    width: fit-content;
  }
`

export const Unassigned = styled.span`
  color: ${({ theme }) => theme.color.content.secondary};
`

const iconStyles = css`
  width: ${({ theme }) => theme.size.icon.small};
  height: ${({ theme }) => theme.size.icon.small};
`

export const DatasetFileCellContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.size.space['02']};
  min-width: 0;
`

export const DatasetFileCellText = styled.div`
  flex: 1;
  min-width: 0;
`

export const DatasetIcon = styled(icons.DatabaseSmall)`
  ${iconStyles}
  flex-shrink: 0;

  & path {
    fill: ${({ theme }) => theme.color.content.secondary};
  }
`

export const FileIcon = styled(icons.FileSmall)`
  ${iconStyles}
  flex-shrink: 0;

  & path {
    fill: ${({ theme }) => theme.color.content.secondary};
  }
`
